import { csrfToken } from './csrf';

function apiFetch(url, options = {}) {
  const method = options.method ? options.method.toUpperCase() : 'GET';
  const headers = options.headers || {};

  if (method !== 'GET' && csrfToken()) {
    headers['X-CSRF-Token'] = csrfToken();
  }

  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      ...headers,
    },
  });
}

export { apiFetch };
